<style lang="less">
.home {
  .profile {
    margin: 5em 0;
    text-align: center;

    .avatar {
      // display: none;
      width: 11em;
      height: 11em;
      margin: 1em auto;
      border: 2px solid #8d6c9f;
      border-radius: 1em;
      background: no-repeat center / cover;
    }

    .name {
      margin-top: 1.6em;
      font-size: 1.4em;
      font-weight: bold;
    }

    .description {
      margin-top: .6em;
      font-size: .95em;
      color: rgba(44, 62, 80, 0.72);
    }
  }

  .content {
    margin: 5em 0 0;
    position: relative;
  }

  .profile {
    background-color: #eceff6;
    .avatar {
      &:hover {
        mix-blend-mode: color-burn;
      }
    }
  }

  @rick-hw-ratio: 372 / 720;
  .rick {
    margin: 0 10px;
    padding-bottom: @rick-hw-ratio * 100%;
    background: url(/static/rick.png) right bottom / 100% auto no-repeat;
  }

  @media (min-width: 800px) {
    & {
      display: flex;
      margin: 0 2em;

      .profile {
        flex: .5 .2 250px;
      }
      .content {
        flex: 2 0 800px - 300px;
      }

      .rick {
        width: 360px;
        padding-bottom: 360px * @rick-hw-ratio;
        position: fixed;
        right: 3em;
        bottom: 0;
        z-index: -1;
      }
    }
  }
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>

<template>
<div class="home">
  <div class="profile">
    <div class="avatar" :style="{
      'background-image': `url(${staticDir + profile.avatar})`
    }"></div>
    <div class="name">{{ profile.name }}</div>
    <div class="description">{{ profile.description }}</div>
  </div>

  <div class="content">
    <transition name="slide-fade" mode="out-in">
      <router-view></router-view>
    </transition>

    <div class="rick"
      title="Via. https://twitter.com/damyata/status/936756526710104064"></div>
  </div>
</div>
</template>

<script>
import {staticDir, profile} from '../data'

export default {
  name: 'Home',
  data () {
    return {
      staticDir,
      profile
    }
  },
  mounted() {
    this.handleTouchStart = ({touches}) => {
      let touch = touches[0]
      this.previousTouchPosX = touch.clientX
      this.previousTouchPosY = touch.clientY
      this.previousTouchStartTime = Date.now()

    }
    this.handleTouchMove = (evt) => {
      let touches = evt.touches
      if (touches.length > 1) {
        // 多指触控，不处理
        return
      }

      let touch = touches[0]

      let deltaPosX = touch.clientX - this.previousTouchPosX
      let deltaPosY = touch.clientY - this.previousTouchPosY

      if (Math.abs(deltaPosY) > Math.abs(deltaPosX) * 7) {
        // 判断为纵向滚动，不做处理
        return
      }
      else {
        // 否则锁定滚动
        // evt.preventDefault()
      }

      this.previousTouchMoveTime = Date.now()
    }
    this.handleTouchEnd = ({changedTouches: touches}) => {
      if (touches.length > 1) {
        return
      }
      let touch = touches[0]
      let deltaPosX = touch.clientX - this.previousTouchPosX
      let touchEndTime = Date.now()
      let deltaTouchStartEnd = touchEndTime - this.previousTouchStartTime
      let deltaTouchMoveEnd = this.previousTouchMoveTime - this.previousTouchStartTime
      if (deltaTouchMoveEnd < 120 && deltaTouchStartEnd < 140 && Math.abs(deltaPosX) > 180) {
        this.$router.push('/music')
      }
    }
    window.addEventListener('touchstart', this.handleTouchStart, false)
    window.addEventListener('touchmove', this.handleTouchMove, false)
    window.addEventListener('touchend', this.handleTouchEnd, false)
  },
  beforeDestroy() {
    window.removeEventListener('touchstart', this.handleTouchStart)
    window.removeEventListener('touchmove', this.handleTouchMove)
    window.removeEventListener('touchend', this.handleTouchEnd)
  }
}
</script>



// WEBPACK FOOTER //
// Home.vue?c23c09c8